import { render, staticRenderFns } from "./NewArrivals.vue?vue&type=template&id=19085d01&"
import script from "./NewArrivals.vue?vue&type=script&lang=js&"
export * from "./NewArrivals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports